import MainLayout from '@layouts/main';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import {
  JSXElementConstructor,
  ReactElement,
  useEffect,
  useState,
} from 'react';

const RouteGuard = (props: {
  children: ReactElement<unknown, string | JSXElementConstructor<unknown>>;
}) => {
  const { children } = props;
  const [moduleEnabled, setModuleEnabled] = useState(false);
  const router = useRouter();
  const { status } = useSession();

  useEffect(() => {
    const isAuthenticated = status === 'authenticated';

    if (router.asPath.includes('/403') || router.asPath.includes('/error')) {
      setModuleEnabled(true);
      return;
    }

    if (!isAuthenticated && !router.asPath.includes('/auth')) {
      return;
    }

    if (router.asPath.includes('/auth')) {
      setModuleEnabled(true);
      return;
    }

    if (isAuthenticated && router.asPath.includes('/support')) {
      setModuleEnabled(true);
      return;
    }

    setModuleEnabled(true);
  }, [router, router.events, status]);

  return moduleEnabled ? (
    children
  ) : (
    <MainLayout breadcrumb={null} panelled={false} showSpinner={true} />
  );
};

export default RouteGuard;
